import React, { VideoHTMLAttributes } from 'react'
import ImageComponent from './ImageComponent'

interface IProps extends VideoHTMLAttributes<any> {
  fallbackThumb: string | undefined
  type?: string
}

const VideoComponent: React.FC<IProps> = ({ fallbackThumb, type, src, ...props }) => {
  return (
    <>
      {src ? (
        <video width={props.width || '300px'} height={props.height || 'auto'} src={src} />
      ) : (fallbackThumb && <ImageComponent fallback={fallbackThumb} />)}
    </>
  )
}
export default VideoComponent
